export default __webpack_public_path__ + "img/portrait_1.d07e03afade53bcb3b68f077cdfd6dca.jpg";